export default "__VITE_ASSET__CiB0wwtR__"